import React, { Component, PropTypes } from 'react';
import './selectConfiguration.scss';

// SVG files from https://github.com/encharm/Font-Awesome-SVG-PNG
import desktopSvg from './desktop.svg';
import mobileSvg from './mobile.svg';

export default class SelectConfiguration extends Component {

  static contextTypes = {
    session: PropTypes.object.isRequired,
    setConfiguration: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  }

  setConfiguration (role, evt) {
    const { setConfiguration } = this.context;
    setConfiguration(role);
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  render () {
    const { session: { configuration }, i18n: _ } = this.context;
    return (
      <div className="select-configuration">
        <h1>
          {_('Select Configuration')}
        </h1>
        <div className="select-btn-container">
          <button
            className={'btn btn-lg button dualScreenBtn ' + ((configuration === 'dualScreen') && 'active')}
              onClick={this.setConfiguration.bind(this, 'dualScreen')}>
              <figure className="icons">
                <img src={desktopSvg} className="desktopSvg" />
                +
                <img src={mobileSvg} className="mobileSvg" />
              </figure>
              <div className="description">
                <h3>{_('Dual Screen')}</h3>
                {_('Classroom Display + Remote')}
              </div>
              <div className="checkmark">
              {(configuration === 'dualScreen') &&
                <i className="glyphicon glyphicon-ok"></i>
              }
              </div>
          </button>
          <button
              className={'btn btn-lg button singleScreenBtn ' + ((configuration === 'singleScreen') && 'active')}
              onClick={this.setConfiguration.bind(this, 'singleScreen')}>
              <figure className="icons">
                <img src={desktopSvg} className="desktopSvg" />
              </figure>
              <div className="description">
                <h3>{_('Single Screen')}</h3>
                {_('Classroom Display Only')}
              </div>
              <div className="checkmark">
              {(configuration === 'singleScreen') &&
                <i className="glyphicon glyphicon-ok"></i>
              }
            </div>
          </button>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/selectConfiguration.js